jQuery(document).ready(function( $ ) {

    // contact form script
    var $group_tags = $('.wpforms-form .list-of-procedures select').find('option[value="group-start"]');

    $group_tags.each(function(i, e) {
        var label = $(e).text();
        $(e).nextUntil($group_tags).wrapAll('<optgroup label="'+label+'" />');
        $(e).remove();
    });

    // fix for empty elementor columns which only have background image
    // and no content to maintain height on mobile, it add extra class to
    // spacer widget to maintain height on small screens
    $('.elementor-element-populated').each(function() {

        let $count = $(this).find('.elementor-widget-wrap').children('div').length;
        if ( $count < 2 ) {
            if ( $(this).css('background-image') !== 'none' ) {
                $(this).find('.elementor-spacer-inner').addClass('dummy-spacer');
            }
        }
    });

    $('.site-copyright p').append('  | <a href="https://www.aestheticbrandmarketing.com/services/online-visibility/?utm_source=Paydar+Plastic+Surgery&amp;utm_medium=link&amp;utm_campaign=plasticsurgerymarketing" target="_blank" rel="noopener">Plastic Surgery Marketing</a> and <a href="https://www.aestheticbrandmarketing.com/plastic-surgery-website-design/?utm_source=Paydar+Plastic+Surgery&amp;utm_medium=link&amp;utm_campaign=plasticsurgerymarketing" target="_blank" rel="noopener">Plastic Surgery Website Design</a> by <a href="https://www.aestheticbrandmarketing.com/?utm_source=Paydar+Plastic+Surgery&amp;utm_medium=link&amp;utm_campaign=abmlogo" target="_blank" rel="noopener"><span class="screen-reader-text">Aesthetic Brand Marketing, Inc.</span><img src="https://paydarplasticsurgery.com/wp-content/themes/paydar/dist/images/abm-logo.svg" width="45" height="13" alt=""></a>');
});